import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UserService } from 'Core/services/user.service';
import { PrimeIcons, MenuItem } from 'primeng/api';
import { EnvironmentService } from 'Core/services/environment.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  logoImage: string;
  logoImageMobile: string;
  messengerUrl: string;
  lists = ['Москва', 'Санкт-Петербург'];
  menuVisible = false;
  mobMenuVisible = false;
  sidebarVisible3: boolean;
  flag = '';
  unreadMessagesCount: number;
  unreadMessagesCountString: string;
  token;
  currentUserProfile;
  items = [
    {
      label: 'Профиль',
      icon: 'pi pi-user',
      command: () => {
        this.goToProfile();
      },
    },
    {
      label: 'Мой дом',
      icon: 'pi pi-home',
      command: () => {
        this.route.navigate(['/user/my-homes']);
      },
    },
    {
      label: 'Выйти',
      icon: 'pi pi-sign-out',
      command: () => {
        this.logout();
      },
    },
  ];
  itemsLand = [
    {
      label: 'Главная',
      icon: 'pi pi-briefcase',
      command: () => {
        this.goToMain();
      },
    },
    {
      label: 'Профиль',
      icon: 'pi pi-user',
      command: () => {
        this.goToProfile();
      },
    },
    {
      label: 'Выйти',
      icon: 'pi pi-sign-out',
      command: () => {
        this.logout();
      },
    },
  ];
  private cookieDomain: string;

  constructor(
    private route: Router,
    private user: UserService,
    private envService: EnvironmentService,
  ) {}

  ngOnInit() {
    this.checkText();
    this.checkUrl();
    this.token = this.checkToken();
    if (this.checkToken()) {
      this.getUserProfile();
    }
    this.messengerUrl = this.envService.getValue('messengerUrl');
    this.cookieDomain = this.envService.getValue('cookieDomain');
    if (window.location.hostname === 'all-work.pro') {
      this.logoImage = '/assets/img/logo/all-work.svg';
      this.logoImageMobile = '/assets/img/logo/all-work.svg';
      this.messengerUrl = 'https://messenger.all-work.pro';
      this.cookieDomain = '*.all-work.pro';
    } else {
      this.logoImage = '/assets/img/logo/bath-dream.svg';
      this.logoImageMobile = '/assets/img/logo/bath-dream-mobile.svg';
    }
  }

  getUserProfile() {
    this.user.getUserProfile().subscribe(
      (success) => {
        this.currentUserProfile = success;
        this.user.getUnreadCount().subscribe((unreadCountSuccess) => {
          this.unreadMessagesCount = unreadCountSuccess.unreadMessagesCount;
          this.unreadMessagesCountString = `${this.unreadMessagesCount}`;
          if (this.unreadMessagesCount > 99) {
            this.unreadMessagesCountString = '99+';
          }
        });
      },
      (error) => {},
    );
  }

  checkToken() {
    return localStorage.getItem('access_token') ? true : false;
  }

  goToProfile() {
    this.route.navigate(['user/profile']);
  }

  logout() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    this.route.navigate(['/auth/login']);
  }

  checkUrl() {
    this.route.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.myFunctionClose();
        this.token = this.checkToken();
        this.checkText();
      }
    });
  }

  checkText() {
    switch (true) {
      case document.location.href.indexOf('user') !== -1:
        if (this.flag == 'auth' && this.checkToken()) {
          this.getUserProfile();
        }
        this.flag = 'user';
        break;
      case document.location.href.indexOf('auth') !== -1:
        this.flag = 'auth';
        break;
      case document.location.href.indexOf('shared') !== -1:
        if (this.flag == 'auth' && this.checkToken()) {
          this.getUserProfile();
        }
        this.flag = 'shared';
        break;
      case document.location.href.indexOf('landing') !== -1:
        if (this.flag == 'auth' && this.checkToken()) {
          this.getUserProfile();
        }
        this.flag = 'landing';
        break;
      default:
        this.flag = '';
    }
  }

  toggleMenu(event: Event) {
    event.preventDefault();
    this.menuVisible = !this.menuVisible;
  }

  goTo() {
    this.route.navigate(['user/orders']);
  }

  goToMain() {
    this.route.navigate(['user/main']);
  }

  goToCalc() {
    this.route.navigate(['shared/step-one']);
  }

  goToAutorization() {
    this.route.navigate(['/auth/login']);
  }

  myFunctionClose() {
    var menu = document.getElementById('myLinks');
    var body = document.getElementsByTagName('body');
    var wrap: any = document.getElementsByClassName('wrap-full-content');
    var tfp: any = document.getElementsByClassName('container');
    var cen: any = document.getElementsByClassName('centered');
    menu.style.display = 'none';
    body[0].style.overflow = 'auto';
    body[0].style.background = 'none';
    this.mobMenuVisible = true;
    // wrap[0].style.display = "block";
    // wrap[0].style.pointerEvents = "auto";
    // tfp[1].style.display = "block";
    // tfp[1].style.pointerEvents = "auto";
    // if(cen?.length > 0) {
    //     cen[0].style.display = "flex";
    // }
  }

  myFunctionOpen() {
    var menu = document.getElementById('myLinks');
    var body = document.getElementsByTagName('body');
    var wrap: any = document.getElementsByClassName('wrap-full-content');
    var tfp: any = document.getElementsByClassName('container');
    var cen: any = document.getElementsByClassName('centered');
    menu.style.display = 'block';
    body[0].style.overflow = 'hidden';
    body[0].style.background = 'grey';
    // wrap[0].style.display = "none";
    // wrap[0].style.pointerEvents = "none";
    // tfp[1].style.display = "none";
    // tfp[1].style.pointerEvents = "none";
    // if(cen?.length > 0) {
    //     cen[0].style.display = "none";;
    // }
  }

  goToMessenger() {
    const access_token = localStorage.getItem('access_token');
    const refresh_token = localStorage.getItem('refresh_token');

    document.cookie = `access_token=${access_token};path=/;domain=${this.cookieDomain}`;
    document.cookie = `refresh_token=${refresh_token};path=/;domain=${this.cookieDomain}`;
    window.open(this.messengerUrl, '_blank');
  }
}
